import React from "react";

const nl2br = (text, senzaMargine = false) =>
  text
    ? text
      .split('\n')
      .map((item, index) =>
        <div className={senzaMargine ? undefined : 'mb-2'} key={index} > {item.length === 0 ? <>{'\u00A0'}</> : item}</div >)
    : '';

export default nl2br;